"use client";
import { DisplayLoadingState, useGenerator } from "@/app/context/GeneratorContext";
import Image from "next/image";
import { useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function DisplayResults() {
  const { displayLoadingState, displayMedia, displayMediaIndex, setDisplayMediaIndex } =
    useGenerator();

  const handleNext = useCallback(() => {
    if (!displayMedia?.length) return;
    const nextIndex = (displayMediaIndex + 1) % displayMedia.length;
    setDisplayMediaIndex(nextIndex);
  }, [displayMedia, displayMediaIndex, setDisplayMediaIndex]);

  const handlePrev = useCallback(() => {
    if (!displayMedia?.length) return;
    const prevIndex = (displayMediaIndex - 1 + displayMedia.length) % displayMedia.length;
    setDisplayMediaIndex(prevIndex);
  }, [displayMedia, displayMediaIndex, setDisplayMediaIndex]);

  if (Array.isArray(displayMedia) && displayMedia.length > 0) {
    return (
      <div className="relative h-[50vh] min-h-[225px] w-full sm:h-[60vh]">
        <div className="relative h-full w-full">
          {displayMedia[displayMediaIndex].type === "gif" ? (
            <video
              src={displayMedia[displayMediaIndex]?.videoUrl}
              controls
              loop
              autoPlay
              className={`absolute h-full w-full border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] object-contain transition-opacity duration-200 ease-in-out [&::-webkit-media-controls-panel]:opacity-0 [&::-webkit-media-controls-panel]:transition-opacity hover:[&::-webkit-media-controls-panel]:opacity-100
                ${displayLoadingState === DisplayLoadingState.Loaded ? "opacity-100" : "opacity-0"}
                ${displayMediaIndex === displayMediaIndex ? "z-10 opacity-100" : "opacity-0"}
              `}
            />
          ) : (
            <Image
              src={displayMedia[displayMediaIndex]?.imageUrl!}
              alt="Generated Image"
              width={500}
              height={500}
              className={`absolute h-full w-full border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] object-contain transition-opacity duration-200 ease-in-out
                ${displayLoadingState === DisplayLoadingState.Loaded ? "opacity-100" : "opacity-0"}
                ${displayMediaIndex === displayMediaIndex ? "z-10 opacity-100" : "opacity-0"}
              `}
            />
          )}

          {displayMedia.length > 1 && (
            <>
              {/* Navigation Buttons */}
              <button
                onClick={handlePrev}
                className="absolute left-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white opacity-75 transition-opacity hover:opacity-100"
              >
                <ChevronLeft className="h-6 w-6" />
              </button>
              <button
                onClick={handleNext}
                className="absolute right-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white opacity-75 transition-opacity hover:opacity-100"
              >
                <ChevronRight className="h-6 w-6" />
              </button>

              {/* Dot Indicators */}
              <div className="absolute bottom-4 left-0 right-0 z-10 flex justify-center gap-2">
                {displayMedia.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setDisplayMediaIndex(index);
                    }}
                    className={`h-2 w-2 rounded-full transition-all ${
                      displayMediaIndex === index ? "bg-white" : "bg-white/50"
                    }`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return null;
}
